// Runtime client config, loaded from /api/config before React mounts, so the Mapbox
// token lives in backend/.env. This does not hide it — mapbox-gl sends it from the
// browser; protection is a URL restriction in the Mapbox dashboard.

let mapboxToken = '';
let googleClientId = '';

export function setMapboxToken(token) {
  mapboxToken = token || '';
}

export function getMapboxToken() {
  return mapboxToken;
}

// Public identifier, not a secret; served from the backend so the two halves of the
// exchange cannot diverge.
export function setGoogleClientId(id) {
  googleClientId = id || '';
}

export function getGoogleClientId() {
  return googleClientId;
}

// False on a host with no edit service: only pre-computed scenarios exist there, so
// nothing that would ask for a simulation may be shown.
let liveSimulation = true;

export function setLiveSimulation(on) {
  liveSimulation = on !== false;
}

export function isLiveSimulation() {
  return liveSimulation;
}

// A demo of one metro: the app opens on it, offers no other, and leaves out what the
// demo does not use (account options at sign-in, sections of the sidebar and the page).
// Empty for the full app.
let demoMetro = '';

export function setDemoMetro(cbsa) {
  demoMetro = cbsa ? String(cbsa) : '';
}

export function getDemoMetro() {
  return demoMetro;
}

export function isDemo() {
  return demoMetro !== '';
}
